import { render, staticRenderFns } from "./CustomInterestRatesTable.vue?vue&type=template&id=72e92f70&scoped=true&"
import script from "./CustomInterestRatesTable.vue?vue&type=script&lang=js&"
export * from "./CustomInterestRatesTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomInterestRatesTable.vue?vue&type=style&index=0&id=72e92f70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e92f70",
  null
  
)

export default component.exports